(function() {
    angular
        .module("app")
        .config(config)
        .run(run)

    config.$inject = [
        "$httpProvider",
        "$compileProvider",
        "$qProvider"
    ]

    let qConf = {}

    function config(
        $httpProvider,
        $compileProvider,
        $qProvider
    ) {
        $httpProvider.interceptors.push("requestService")
        $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|blob|mailto|file):/)

        qConf.showRejectionErrors = (value) => {
            $qProvider.errorOnUnhandledRejections(value)
        }
    }

    run.$inject = [
        "$rootScope",
        "globals",
        "$state",
        "$transitions",
        "$cookies",
        "ENV_CONFIG",
        "prefs",
        "googleMapsService",
        "noticeService",
        "version",
        "authorizationService"
    ]

    function run(
        $rootScope,
        globals, // Required even if unused
        $state,
        $transitions,
        $cookies,
        ENV_CONFIG,
        prefs,
        googleMapsService,
        noticeService,
        version,
        authorizationService
    ) {

        // .replaceAll is not available on recently older browsers
        // https://stackoverflow.com/questions/1144783/how-to-replace-all-occurrences-of-a-string-in-javascript
        if (String.prototype.replaceAll === undefined) {
            String.prototype.replaceAll = function(find, replace) {
                const escapedFind = find.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
                return this.replace(new RegExp(escapedFind, "g"), replace)
            }
        }

        // Restore permission state from sessionStorage (page refresh recovery)
        authorizationService.restoreFromSession()

        const configuration = {
            cookieDomain:  "invalid",
            apiUrl:        "invalid",
            realIP:        undefined,
            label:         "invalid",
            showLabel:     false,
            pubNubPrefix:  "invalid",
            pubNubSubKey:  "invalid",
            fmPushEnabled: false,
            fmPushWSUrl:   "invalid",
            fmPushSSEUrl:  "invalid",
            debugConsole:  false,
            versions:      version.load(),
            v2AppUrl:      "invalid"
        }

        if (ENV_CONFIG) {
            if (ENV_CONFIG.hasOwnProperty("cookieDomain"))  { configuration.cookieDomain  = ENV_CONFIG.cookieDomain  }
            if (ENV_CONFIG.hasOwnProperty("apiUrl"))        { configuration.apiUrl        = ENV_CONFIG.apiUrl        }
            if (ENV_CONFIG.hasOwnProperty("realIP"))        { configuration.realIP        = ENV_CONFIG.realIP        }
            if (ENV_CONFIG.hasOwnProperty("label"))         { configuration.label         = ENV_CONFIG.label         }
            if (ENV_CONFIG.hasOwnProperty("showLabel"))     { configuration.showLabel     = ENV_CONFIG.showLabel     }
            if (ENV_CONFIG.hasOwnProperty("pubNubPrefix"))  { configuration.pubNubPrefix  = ENV_CONFIG.pubNubPrefix  }
            if (ENV_CONFIG.hasOwnProperty("pubNubSubKey"))  { configuration.pubNubSubKey  = ENV_CONFIG.pubNubSubKey  }
            if (ENV_CONFIG.hasOwnProperty("fmPushEnabled")) { configuration.fmPushEnabled = ENV_CONFIG.fmPushEnabled }
            if (ENV_CONFIG.hasOwnProperty("fmPushWSUrl"))   { configuration.fmPushWSUrl   = ENV_CONFIG.fmPushWSUrl   }
            if (ENV_CONFIG.hasOwnProperty("fmPushSSEUrl"))  { configuration.fmPushSSEUrl  = ENV_CONFIG.fmPushSSEUrl  }
            if (ENV_CONFIG.hasOwnProperty("mapsAPIKey"))    { configuration.mapsAPIKey    = ENV_CONFIG.mapsAPIKey    }
            if (ENV_CONFIG.hasOwnProperty("debugConsole"))  { configuration.debugConsole  = ENV_CONFIG.debugConsole  }
            if (ENV_CONFIG.hasOwnProperty("v2AppUrl"))      { configuration.v2AppUrl      = ENV_CONFIG.v2AppUrl      }
        }

        const authPages = [
            "/login",
            "/forgot",
            "/password-reset/:password_reset_token",
            "/user-confirmation/:confirmation_token"
        ]

        // Permission-based route guards: maps route URLs to required permissions or scopes
        const routePermissions = {
            "/customers/:customer_id/api/":                                  "ApiGeneralRead",
            "/customers/:customer_id/api/configs/:api_config_id/documentation": "ApiGeneralRead",
            "/customers/:customer_id/api/documentation-wzdx":                "ApiGeneralRead",
            "/users":                                                        "UserRead",
            "/customers":                                                    "CustomerRead",
            "/customers/customer-id/:customer_id":                           "CustomerRead",
            "/devices/customer-id/:customer_id":                             "CustomerRead",
            "/feedback":                                                     "SystemFeedbackRead"
        }

        const routeScopeRequired = {
            "/global-search":                "other_customer",
            "/global-deployed-arrow-boards": "other_customer"
        }

        const messagePages = [
            "/new",
            "/new-text",
            "/new-graphic",
            "/preview",
            "/confirm",
            "/confirm-graphic"
        ]

        const tabPages = [
            "/details",
            "/map",
            "/all",
            "/telemetry",
            "/alerts",
            "/schedule",
            "/stored-messages",
            "/customers-search",
            "/devices-search",
            "/users-search"
        ]

        const deviceStates = [
            "device-message-board.details",
            "device-message-board.map",
            "device-message-board.history.all",
            "device-message-board.history.telemetry",
            "device-message-board.history.alerts",
            "device-message-board.schedule",
            "device-message-board.stored_messages",
            "device-tracker.details",
            "device-tracker.history.all",
            "device-tracker.history.telemetry",
            "device-tracker.history.alerts"
        ]

        const globalSearchStates = [
            "customer-search.view",
            "devices-search.view",
            "users-search.view"
        ]

        if (typeof $cookies.getObject("tutorials.device") == "undefined") {
            $cookies.putObject("tutorials.device", true)
        }
        if (typeof $cookies.getObject("tutorials.deviceDetails") == "undefined") {
            $cookies.putObject("tutorials.deviceDetails", true)
        }

        $rootScope.tutorials = {
            device: $cookies.getObject("tutorials.device"),
            deviceDetails: $cookies.getObject("tutorials.deviceDetails")
        }

        /**
            $rootScope variables
            @type {boolean}
         **/
        $rootScope.config = configuration

        googleMapsService.install()

        $rootScope.is_authenticated = false
        $rootScope.displayNotice    = undefined

        $rootScope.customerIsIowaDOT = () => {
            if ($rootScope.hasOwnProperty("user") && $rootScope.user.hasOwnProperty("customer_id")) {
                if ($rootScope.config.label === "FM Docker") {
                    return $rootScope.user.customer_id === 2 // Docker ACME
                } else if ($rootScope.config.label === "FM Test") {
                    return [12733, 12738].contains($rootScope.user.customer_id) // Iowa DOT in FM Test
                } else {
                    return [13017, 13642].contains($rootScope.user.customer_id) // Iowa DOT in FM Prod
                }
            }
            return false
        }

        $rootScope.getUserCustomerAndChildren = () => {

            let customers = []

            if ($rootScope.user && $rootScope.user.customer_id) {

                for (const customer of $rootScope.customers) {

                    if (customer.id === $rootScope.user.customer_id) {

                        customers.push(customer)

                        const getChildren = (subs) => {
                            let subCustomers = []
                            if (subs) {
                                for (const sub of subs) {
                                    subCustomers.push(sub)
                                    subCustomers = subCustomers.concat(getChildren(sub.subs))
                                }
                            }
                            return subCustomers
                        }

                        customers = customers.concat(getChildren(customer.subs))

                        break

                    }
                }
            }

            console.log([...customers])
            return customers

        }

        $rootScope.$watch("is_authenticated", function() {

            if ($rootScope.is_authenticated) {

                $rootScope.isWancoUser = $rootScope.user.customer_id == 1
                $rootScope.isSuperRoot = $rootScope.isWancoUser && $rootScope.user.role == "superroot"
                $rootScope.isRoot      = $rootScope.isWancoUser && $rootScope.user.role == "root"

                $rootScope.can = (p, cid) => authorizationService.can(p, cid)
                $rootScope.hasScope = (s) => authorizationService.hasScope(s)

                $rootScope.selectedCustomerID = $rootScope.user.customer_id
                gtag("set", { target_customer: $rootScope.user.customer_name })

                noticeService.getLatestUnreadNotice($rootScope.user.id)

            } else {

                $rootScope.user = {}
                $rootScope.customers = []

                $rootScope.isWancoUser = false
                $rootScope.isSuperRoot = false
                $rootScope.isRoot      = false

                $rootScope.can = () => false
                $rootScope.hasScope = () => false

                $rootScope.selectedCustomerID = undefined
                gtag("set", { target_customer: null })
                $rootScope.displayNotice      = undefined

            }
        })

        const user = $cookies.getObject("user")
        $rootScope.selectedCustomerID = undefined
        $rootScope.debug              = false
        $rootScope.user               = Object.prototype.toString.call(user) === "[object Object]" ? user : {}
        $rootScope.remember_user      = $cookies.getObject("remember_user") || {}
        $rootScope.hasApiAccess       = false
        $rootScope.hasWZDxFFAccess    = false
        $rootScope.apiConfigID        = undefined
        $rootScope.is_authenticated   = $rootScope.user.hasOwnProperty("username")

        let transitionDelayed = false

        $transitions.onBefore({}, function(trans) {

            const target = trans.to()

            if (!$rootScope.is_authenticated) {

                if (authPages.indexOf(target.url) === -1 && target.url !== "/login") {
                    trans.abort()
                    $state.go("login")
                }
            }

            const requiredPermission = routePermissions[target.url]
            if (requiredPermission && !$rootScope.can(requiredPermission)) {
                trans.abort()
                $state.go("devices")
            }

            const requiredScope = routeScopeRequired[target.url]
            if (requiredScope && !$rootScope.hasScope(requiredScope)) {
                trans.abort()
                $state.go("devices")
            }

            if (authPages.indexOf(target.url) === -1) {

                // Before any transition from one page to another, check Preferences has been initialized.
                // In certain cases, Pref initialization requires retrieving updated API User data
                // If so, this method stops the current transition, waits for the API to respond
                // and then restarts the transition.
                //
                // Note:
                //   $qProvider configuration set to ignore unhandled rejections to eliminate console errors in certain situations
                //
                // https://ui-router.github.io/ng1/docs/latest/interfaces/transition.ihookregistry.html

                if ($rootScope.is_authenticated) {

                    if (prefs.needsAsyncInit()) {

                        // Prefs requires retrieving data from API
                        transitionDelayed = true

                        // Eliminate console errors in certain situations
                        qConf.showRejectionErrors(false)

                        const success = () => {

                            transitionDelayed = false

                            // Restore console errors
                            qConf.showRejectionErrors(true)

                            // Restart transition
                            $state.go(target.name, trans._targetState._params, trans._targetState._options)

                        }

                        const failure = () => {

                            transitionDelayed = false

                            // Restore console errors
                            qConf.showRejectionErrors(true)

                        }

                        prefs.init(success, failure)

                        // Stop current transition
                        trans.abort()

                    } else {

                        prefs.init()

                        if (transitionDelayed) {
                            console.warn("Double Transition Averted!")
                            // Stop current transition
                            trans.abort()

                        }
                    }
                }
            }
        })

        $transitions.onStart({}, function(trans) {

            let prev = trans.from()
            let next = trans.to()

            $rootScope.previousState = prev.name
            $rootScope.alertSuccess = false
            $rootScope.alertFailure = false
            $rootScope.alertFailureMessages = []
            $rootScope.alertSuccessMessages = []
            $rootScope.deviceDetailsPage = deviceStates.indexOf(next.name) != -1
            $rootScope.devicesPage = next.name == "/" || next.name == "devices"
            $rootScope.isMessageCreate = messagePages.indexOf(next.url) >= 0

            if (tabPages.indexOf(next.url) === -1) {
                document.body.scrollTop = document.documentElement.scrollTop = 0
            }
        })

        $rootScope.geoISORegions = [
            "US-AL",
            "US-AK",
            "US-AZ",
            "US-AR",
            "US-CA",
            "US-CO",
            "US-CT",
            "US-DE",
            "US-FL",
            "US-GA",
            "US-HI",
            "US-ID",
            "US-IL",
            "US-IN",
            "US-IA",
            "US-KS",
            "US-KY",
            "US-LA",
            "US-ME",
            "US-MD",
            "US-MA",
            "US-MI",
            "US-MN",
            "US-MS",
            "US-MO",
            "US-MT",
            "US-NE",
            "US-NV",
            "US-NH",
            "US-NJ",
            "US-NM",
            "US-NY",
            "US-NC",
            "US-ND",
            "US-OH",
            "US-OK",
            "US-OR",
            "US-PA",
            "US-RI",
            "US-SC",
            "US-SD",
            "US-TN",
            "US-TX",
            "US-UT",
            "US-VT",
            "US-VA",
            "US-WA",
            "US-WV",
            "US-WI",
            "US-WY"
        ]

        $rootScope.timezones = [
            {value: "American Samoa", label: "(GMT-11:00) American Samoa"},
            {value: "International Date Line West", label: "(GMT-11:00) International Date Line West"},
            {value: "Midway Island", label: "(GMT-11:00) Midway Island"},
            {value: "Samoa", label: "(GMT-11:00) Samoa"},
            {value: "Hawaii", label: "(GMT-10:00) Hawaii"},
            {value: "Alaska", label: "(GMT-09:00) Alaska"},
            {value: "Pacific Time (US & Canada)", label: "(GMT-08:00) Pacific Time (US & Canada)"},
            {value: "Tijuana", label: "(GMT-08:00) Tijuana"},
            {value: "Arizona", label: "(GMT-07:00) Arizona"},
            {value: "Chihuahua", label: "(GMT-07:00) Chihuahua"},
            {value: "Mazatlan", label: "(GMT-07:00) Mazatlan"},
            {value: "Mountain Time (US & Canada)", label: "(GMT-07:00) Mountain Time (US & Canada)"},
            {value: "Central America", label: "(GMT-06:00) Central America"},
            {value: "Central Time (US & Canada)", label: "(GMT-06:00) Central Time (US & Canada)"},
            {value: "Guadalajara", label: "(GMT-06:00) Guadalajara"},
            {value: "Mexico City", label: "(GMT-06:00) Mexico City"},
            {value: "Monterrey", label: "(GMT-06:00) Monterrey"},
            {value: "Saskatchewan", label: "(GMT-06:00) Saskatchewan"},
            {value: "Bogota", label: "(GMT-05:00) Bogota"},
            {value: "Eastern Time (US & Canada)", label: "(GMT-05:00) Eastern Time (US & Canada)"},
            {value: "Indiana (East)", label: "(GMT-05:00) Indiana (East)"},
            {value: "Lima", label: "(GMT-05:00) Lima"},
            {value: "Quito", label: "(GMT-05:00) Quito"},
            {value: "Atlantic Time (Canada)", label: "(GMT-04:00) Atlantic Time (Canada)"},
            {value: "Caracas", label: "(GMT-04:00) Caracas"},
            {value: "Georgetown", label: "(GMT-04:00) Georgetown"},
            {value: "La Paz", label: "(GMT-04:00) La Paz"},
            {value: "Santiago", label: "(GMT-04:00) Santiago"},
            {value: "Newfoundland", label: "(GMT-03:30) Newfoundland"},
            {value: "Brasilia", label: "(GMT-03:00) Brasilia"},
            {value: "Buenos Aires", label: "(GMT-03:00) Buenos Aires"},
            {value: "Greenland", label: "(GMT-03:00) Greenland"},
            {value: "Montevideo", label: "(GMT-03:00) Montevideo"},
            {value: "Mid-Atlantic", label: "(GMT-02:00) Mid-Atlantic"},
            {value: "Azores", label: "(GMT-01:00) Azores"},
            {value: "Cape Verde Is.", label: "(GMT-01:00) Cape Verde Is."},
            {value: "Casablanca", label: "(GMT+00:00) Casablanca"},
            {value: "Dublin", label: "(GMT+00:00) Dublin"},
            {value: "Edinburgh", label: "(GMT+00:00) Edinburgh"},
            {value: "Lisbon", label: "(GMT+00:00) Lisbon"},
            {value: "London", label: "(GMT+00:00) London"},
            {value: "Monrovia", label: "(GMT+00:00) Monrovia"},
            {value: "UTC", label: "(GMT+00:00) UTC"},
            {value: "Amsterdam", label: "(GMT+01:00) Amsterdam"},
            {value: "Belgrade", label: "(GMT+01:00) Belgrade"},
            {value: "Berlin", label: "(GMT+01:00) Berlin"},
            {value: "Bern", label: "(GMT+01:00) Bern"},
            {value: "Bratislava", label: "(GMT+01:00) Bratislava"},
            {value: "Brussels", label: "(GMT+01:00) Brussels"},
            {value: "Budapest", label: "(GMT+01:00) Budapest"},
            {value: "Copenhagen", label: "(GMT+01:00) Copenhagen"},
            {value: "Ljubljana", label: "(GMT+01:00) Ljubljana"},
            {value: "Madrid", label: "(GMT+01:00) Madrid"},
            {value: "Paris", label: "(GMT+01:00) Paris"},
            {value: "Prague", label: "(GMT+01:00) Prague"},
            {value: "Rome", label: "(GMT+01:00) Rome"},
            {value: "Sarajevo", label: "(GMT+01:00) Sarajevo"},
            {value: "Skopje", label: "(GMT+01:00) Skopje"},
            {value: "Stockholm", label: "(GMT+01:00) Stockholm"},
            {value: "Vienna", label: "(GMT+01:00) Vienna"},
            {value: "Warsaw", label: "(GMT+01:00) Warsaw"},
            {value: "West Central Africa", label: "(GMT+01:00) West Central Africa"},
            {value: "Zagreb", label: "(GMT+01:00) Zagreb"},
            {value: "Athens", label: "(GMT+02:00) Athens"},
            {value: "Bucharest", label: "(GMT+02:00) Bucharest"},
            {value: "Cairo", label: "(GMT+02:00) Cairo"},
            {value: "Harare", label: "(GMT+02:00) Harare"},
            {value: "Helsinki", label: "(GMT+02:00) Helsinki"},
            {value: "Jerusalem", label: "(GMT+02:00) Jerusalem"},
            {value: "Kaliningrad", label: "(GMT+02:00) Kaliningrad"},
            {value: "Kyiv", label: "(GMT+02:00) Kyiv"},
            {value: "Pretoria", label: "(GMT+02:00) Pretoria"},
            {value: "Riga", label: "(GMT+02:00) Riga"},
            {value: "Sofia", label: "(GMT+02:00) Sofia"},
            {value: "Tallinn", label: "(GMT+02:00) Tallinn"},
            {value: "Vilnius", label: "(GMT+02:00) Vilnius"},
            {value: "Baghdad", label: "(GMT+03:00) Baghdad"},
            {value: "Istanbul", label: "(GMT+03:00) Istanbul"},
            {value: "Kuwait", label: "(GMT+03:00) Kuwait"},
            {value: "Minsk", label: "(GMT+03:00) Minsk"},
            {value: "Moscow", label: "(GMT+03:00) Moscow"},
            {value: "Nairobi", label: "(GMT+03:00) Nairobi"},
            {value: "Riyadh", label: "(GMT+03:00) Riyadh"},
            {value: "St. Petersburg", label: "(GMT+03:00) St. Petersburg"},
            {value: "Volgograd", label: "(GMT+03:00) Volgograd"},
            {value: "Tehran", label: "(GMT+03:30) Tehran"},
            {value: "Abu Dhabi", label: "(GMT+04:00) Abu Dhabi"},
            {value: "Baku", label: "(GMT+04:00) Baku"},
            {value: "Muscat", label: "(GMT+04:00) Muscat"},
            {value: "Samara", label: "(GMT+04:00) Samara"},
            {value: "Tbilisi", label: "(GMT+04:00) Tbilisi"},
            {value: "Yerevan", label: "(GMT+04:00) Yerevan"},
            {value: "Kabul", label: "(GMT+04:30) Kabul"},
            {value: "Ekaterinburg", label: "(GMT+05:00) Ekaterinburg"},
            {value: "Islamabad", label: "(GMT+05:00) Islamabad"},
            {value: "Karachi", label: "(GMT+05:00) Karachi"},
            {value: "Tashkent", label: "(GMT+05:00) Tashkent"},
            {value: "Chennai", label: "(GMT+05:30) Chennai"},
            {value: "Kolkata", label: "(GMT+05:30) Kolkata"},
            {value: "Mumbai", label: "(GMT+05:30) Mumbai"},
            {value: "New Delhi", label: "(GMT+05:30) New Delhi"},
            {value: "Sri Jayawardenepura", label: "(GMT+05:30) Sri Jayawardenepura"},
            {value: "Kathmandu", label: "(GMT+05:45) Kathmandu"},
            {value: "Almaty", label: "(GMT+06:00) Almaty"},
            {value: "Astana", label: "(GMT+06:00) Astana"},
            {value: "Dhaka", label: "(GMT+06:00) Dhaka"},
            {value: "Urumqi", label: "(GMT+06:00) Urumqi"},
            {value: "Rangoon", label: "(GMT+06:30) Rangoon"},
            {value: "Bangkok", label: "(GMT+07:00) Bangkok"},
            {value: "Hanoi", label: "(GMT+07:00) Hanoi"},
            {value: "Jakarta", label: "(GMT+07:00) Jakarta"},
            {value: "Krasnoyarsk", label: "(GMT+07:00) Krasnoyarsk"},
            {value: "Novosibirsk", label: "(GMT+07:00) Novosibirsk"},
            {value: "Beijing", label: "(GMT+08:00) Beijing"},
            {value: "Chongqing", label: "(GMT+08:00) Chongqing"},
            {value: "Hong Kong", label: "(GMT+08:00) Hong Kong"},
            {value: "Irkutsk", label: "(GMT+08:00) Irkutsk"},
            {value: "Kuala Lumpur", label: "(GMT+08:00) Kuala Lumpur"},
            {value: "Perth", label: "(GMT+08:00) Perth"},
            {value: "Singapore", label: "(GMT+08:00) Singapore"},
            {value: "Taipei", label: "(GMT+08:00) Taipei"},
            {value: "Ulaanbaatar", label: "(GMT+08:00) Ulaanbaatar"},
            {value: "Osaka", label: "(GMT+09:00) Osaka"},
            {value: "Sapporo", label: "(GMT+09:00) Sapporo"},
            {value: "Seoul", label: "(GMT+09:00) Seoul"},
            {value: "Tokyo", label: "(GMT+09:00) Tokyo"},
            {value: "Yakutsk", label: "(GMT+09:00) Yakutsk"},
            {value: "Adelaide", label: "(GMT+09:30) Adelaide"},
            {value: "Darwin", label: "(GMT+09:30) Darwin"},
            {value: "Brisbane", label: "(GMT+10:00) Brisbane"},
            {value: "Canberra", label: "(GMT+10:00) Canberra"},
            {value: "Guam", label: "(GMT+10:00) Guam"},
            {value: "Hobart", label: "(GMT+10:00) Hobart"},
            {value: "Melbourne", label: "(GMT+10:00) Melbourne"},
            {value: "Port Moresby", label: "(GMT+10:00) Port Moresby"},
            {value: "Sydney", label: "(GMT+10:00) Sydney"},
            {value: "Vladivostok", label: "(GMT+10:00) Vladivostok"},
            {value: "Magadan", label: "(GMT+11:00) Magadan"},
            {value: "New Caledonia", label: "(GMT+11:00) New Caledonia"},
            {value: "Solomon Is.", label: "(GMT+11:00) Solomon Is."},
            {value: "Srednekolymsk", label: "(GMT+11:00) Srednekolymsk"},
            {value: "Auckland", label: "(GMT+12:00) Auckland"},
            {value: "Fiji", label: "(GMT+12:00) Fiji"},
            {value: "Kamchatka", label: "(GMT+12:00) Kamchatka"},
            {value: "Marshall Is.", label: "(GMT+12:00) Marshall Is."},
            {value: "Wellington", label: "(GMT+12:00) Wellington"},
            {value: "Chatham Is.", label: "(GMT+12:45) Chatham Is."},
            {value: "Nuku'alofa", label: "(GMT+13:00) Nuku'alofa"},
            {value: "Tokelau Is.", label: "(GMT+13:00) Tokelau Is."}
        ]

    }
})()
